import Vue from "vue";
import Vuex from "vuex";
import axios from "../axiosClient";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    user: JSON.parse(localStorage.getItem("user") || "{}"),
    lastChallenge: JSON.parse(localStorage.getItem("lastChallenge") || "{}"),
    selectedChallenge: {},
    challenges: JSON.parse(localStorage.getItem("challenges") || "{}"),
    disciplines: JSON.parse(localStorage.getItem("disciplines") || "{}")
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, payload) {
      state.status = "success";
      state.token = payload.token;
      state.user = payload.user;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
    },
    set_user(state, user) {
      state.user = user;
    },
    updateLastChallenge(state, lastChallenge) {
      state.lastChallenge = lastChallenge;
    },
    updateSelectedChallenge(state, selectedChallenge) {
      state.selectedChallenge = selectedChallenge;
    },
    updateChallenges(state, challenges) {
      state.challenges = challenges.map((challenge, index) => {
        return {
          challengeOrder: index + 1,
          ...challenge
        };
      });
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({ url: "login", data: user, method: "POST" })
          .then(response => {
            const token = response.data.data.api_token;
            const user = response.data.data;
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.removeItem("lastChallenge");
            localStorage.removeItem("challenges");

            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

            commit("auth_success", { token, user });
            resolve(response);
          })
          .catch(error => {
            commit("auth_error");
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            reject(error);
          });
      });
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({ url: "register", data: user, method: "POST" })
          .then(response => {
            const token = response.data.data.api_token;
            const user = response.data.data;
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.removeItem("lastChallenge");
            localStorage.removeItem("challenges");
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

            commit("auth_success", { token, user });
            resolve(response);
          })
          .catch(error => {
            commit("auth_error", error);
            localStorage.removeItem("token");
            localStorage.removeItem("user");

            reject(error);
          });
      });
    },
    logout({ commit }) {
      return new Promise(resolve => {
        commit("logout");
        localStorage.removeItem("lastChallenge");
        localStorage.removeItem("challenges");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        resolve();
      });
    },
    fetchUser(context) {
      if (navigator.onLine) {
        return new Promise((resolve, reject) => {
          axios("user")
            .then(response => {
              const user = response.data.data;
              context.commit("set_user", response.data.data);
              localStorage.setItem("user", JSON.stringify(user));
              resolve(response);
            })
            .catch(error => {
              localStorage.removeItem("token");
              localStorage.removeItem("user");
              reject(error);
            });
        });
      } else {
        context.commit("set_user", JSON.parse(localStorage.getItem("user")));
      }
    },

    sendResetEmail({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios({ url: "password/email", data: data, method: "POST" })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            commit("auth_error", error);
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            reject(error);
          });
      });
    },

    passwordReset({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios({ url: "password/reset", data: data, method: "POST" })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            commit("auth_error", error);
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            reject(error);
          });
      });
    },

    // eslint-disable-next-line no-unused-vars
    fetchLastChallenge(context, challengeId = null) {
      // if (context.state.lastChallenge.id) return; // se já está setado, não vamos fazer nada.
      if (navigator.onLine) {
        axios
          .get(`users/${context.getters.user.id}/challenge`)
          .then(response => {
            context.commit("updateLastChallenge", response.data.data);
            localStorage.setItem(
              "lastChallenge",
              JSON.stringify(response.data.data)
            );
            if (!response.data.data) {
              localStorage.removeItem("lastChallenge");
            }
          });
      } else {
        context.commit(
          "updateLastChallenge",
          JSON.parse(localStorage.getItem("lastChallenge"))
        );
      }
    },
    fetchChallenges(context) {
      // if (context.state.lastChallenge.id) return; // se já está setado, não vamos fazer nada.
      if (navigator.onLine) {
        axios
          .get(`users/${context.getters.user.id}/challenges`)
          .then(response => {
            response.data.data.reverse();
            context.commit("updateChallenges", response.data.data);
            localStorage.setItem(
              "challenges",
              JSON.stringify(response.data.data)
            );
          });
      } else {
        this.challenges = JSON.parse(localStorage.getItem("challenges"));
      }
    },

    fetchSelectedChallenge(context, challengeId) {
      return new Promise((resolve, reject) => {
        axios(`/challenges/${challengeId}`)
          .then(response => {
            context.commit("updateSelectedChallenge", response.data.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Vamos usar essa action para evitar ver "antes" outro challenge do que o selected.
    cleanSelectedChallenge(context) {
      context.commit("updateSelectedChallenge", {});
    },

    generateNewChallenge(context) {
      return new Promise((resolve, reject) => {
        axios
          .post(`users/${context.getters.user.id}/challenges/create`)
          .then(response => {
            context.commit("updateLastChallenge", response.data.data);
            context.dispatch("fetchLastChallenge");
            context.dispatch("fetchChallenges");
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    user: state => {
      if (state.user) return state.user;
      if (!state.user && localStorage.getItem("user")) {
        return JSON.parse(localStorage.getItem("user"));
      }
    },
    getToken: state => state.token,
    lastChallenge: state => state.lastChallenge
  }
});
